// #region imports

// --- 3rd Party
import { cloneDeep } from "lodash";

// --- HS Code
import { RemoteCommand } from "./remote-command";
import { CommandResult } from "./command-result";
import { CommandTypes } from "./command-types";

// #endregion

export class UpdateCommand<TTarget> implements RemoteCommand {
  private _currentValues: any[] = [];

  get commandType(): CommandTypes {
    return CommandTypes.update;
  }

  commandResult: CommandResult | undefined;
  isExecuted: boolean;

  constructor(
    private _target: TTarget,
    public commandId: number,
    public identifier: string,
    public propertyNames: (keyof(TTarget))[],
    public newValues: any[]
  ) {
    this.isExecuted = false;
    this.propertyNames.forEach(key => {
      this._currentValues.push(this._target[key]);
    });
  }

  undo(): UpdateCommand<TTarget> {
    if (!this.isExecuted) throw new Error("Command not yet executed. Cannot undo.");
    if (!this.commandResult?.isSuccessful) throw new Error('Command did not complete successfully. Cannot undo.')

    const newTarget = cloneDeep(this._target);
    this.propertyNames.forEach((key, index) => {
      newTarget[key] = this.newValues[index];
    });
    return new UpdateCommand(newTarget, this.commandId, this.identifier, this.propertyNames, this._currentValues);
  }

  createCommandDto(): any {
    return {
      commandId: this.commandId,
      identifier: this.identifier,
      commandType: this.commandType,
      target: this._target,
      propertyNames: this.propertyNames,
      newValues: this.newValues
    }
  }
}
